import * as React from 'react';
import * as smi from './style.module.scss';
import data from './data.json';
export const SmiAboutUs = ({ sectionName, ttlName }) => {
  return (
    <section className={sectionName}>
      <div className="container">
        <h2 className={ttlName}>СМИ о нас</h2>
        <div className={`row ${smi.row}`}>
          <div className={smi.smiText}>
            <p>
              Технологиями Advance уже в&nbsp;2012 году заинтересовались федеральные каналы. В&nbsp;этом разделе
              мы&nbsp;собрали основные репортажи и&nbsp;статьи из&nbsp;экспертных изданий.
            </p>
            <p>
              Читайте, смотрите&nbsp;— в&nbsp;интервью вы&nbsp;узнаете, что думают Николай Ягодкин и&nbsp;Александр
              Згода об&nbsp;образовании, обучении, бизнесе и&nbsp;развитии личности!
            </p>
          </div>

          {data.map((elem, index) => (
            <div className={`col-sm-12 col-md-auto col-lg-3 ${smi.smiCol}`} key={index}>
              <div className={smi.smiBlock}>
                <a href={elem.link} target={'_blank'} rel={'nofollow, noreferrer'}>
                  <img src={elem.imgSrc} alt={elem.imgAlt} />
                </a>
              </div>
              <p className={smi.smiBlockNote}>{elem.title}</p>
              <p className={smi.smiBlockNoteMin}>{elem.description ? elem.description : null}</p>
            </div>
          ))}

          {/*<div className="col-sm-12 col-md-auto col-lg-3 smi-col">*/}
          {/*  <a target="_blank" href="/about/news/aif_peterburg/" rel="nofollow">*/}
          {/*    <div className="smi-block">*/}
          {/*      <img src="https://fs.advance.ru/landing-pages/images/about_us/smi/aif-logo.jpg"*/}
          {/*           alt="Николай Ягодкин в гостях «АиФ – Петербург»">*/}
          {/*    </div>*/}
          {/*    <p className="smi-block-note">Николай Ягодкин в&nbsp;гостях <br>«АиФ&nbsp;– Петербург»</p>*/}
          {/*  </a>*/}
          {/*</div>*/}

          {/*<div className="col-sm-12 col-md-auto col-lg-3 smi-col">*/}
          {/*  <div className="sidebar-pos">*/}
          {/*    <a href="/about/news/advance_na_telekanale_78/" rel="nofollow">*/}
          {/*      <img src="https://fs.advance.ru/landing-pages/images/about_us/smi/78t.jpg" alt="Телеканал <br>«78»">*/}
          {/*    </a>*/}
          {/*  </div>*/}
          {/*  <p className="smi-block-note">Телеканал <br>«78»</p>*/}
          {/*  <p className="smi-block-note-min">О технологии изучения иностранных языков</p>*/}
          {/*</div>*/}

          {/*<div className="col-sm-12 col-md-auto col-lg-3 smi-col">*/}
          {/*  <a target="_blank" href="/about/news/chtd/" rel="nofollow">*/}
          {/*    <div className="smi-block">*/}
          {/*      <img src="https://fs.advance.ru/landing-pages/images/about_us/smi/chtd-logo.jpg"*/}
          {/*           alt="Английский с нуля за две недели: секреты памяти">*/}
          {/*    </div>*/}
          {/*    <p className="smi-block-note">Английский с&nbsp;нуля за&nbsp;две недели: секреты памяти</p>*/}
          {/*    <p className="smi-block-note-min">«ЧТД» – онлайн-издание про образование и&nbsp;развитие взрослых</p>*/}
          {/*  </a>*/}
          {/*</div>*/}

          {/*<div className="col-sm-12 col-md-auto col-lg-3 smi-col">*/}
          {/*  <div className="sidebar-pos">*/}
          {/*    <a href="/about/news/advance_popal_na_telekanal_tvc/" rel="nofollow">*/}
          {/*      <img src="https://fs.advance.ru/landing-pages/images/about_us/smi/tvc.jpg"*/}
          {/*           alt="Телеканал <br>«ТВ Центр»">*/}
          {/*    </a>*/}
          {/*  </div>*/}
          {/*  <p className="smi-block-note">Телеканал <br>«ТВ Центр»</p>*/}
          {/*  <p className="smi-block-note-min">Как удержать в&nbsp;голове большой объём информации?</p>*/}
          {/*</div>*/}

          {/*<div className="col-sm-12 col-md-auto col-lg-3 smi-col">*/}
          {/*  <div className="sidebar-pos">*/}
          {/*    <a href="/about/news/advance_na_telekanale_sankt_peterburg_kak_uchitsya_pravilno/" rel="nofollow">*/}
          {/*      <img src="https://fs.advance.ru/landing-pages/images/about_us/smi/spb-logo.jpg"*/}
          {/*           alt="Телеканал «Санкт-Петербург»">*/}
          {/*    </a>*/}
          {/*  </div>*/}
          {/*  <p className="smi-block-note">Телеканал <br>«Санкт-Петербург»</p>*/}
          {/*  <p className="smi-block-note-min">Английский как инвестиция и о центре Advance</p>*/}
          {/*</div>*/}

          {/*<div className="col-sm-12 col-md-auto col-lg-3 smi-col">*/}
          {/*  <a href="/about/news/zhurnal_ponedelnik_vyipustil_statyu_pro_nikolaya_yagodkina/" rel="nofollow">*/}
          {/*    <div className="smi-block">*/}
          {/*      <img src="https://fs.advance.ru/landing-pages/images/about_us/smi/ponedelnik-logo.jpg"*/}
          {/*           alt="Понедельник: Дело его жизни: Николай Ягодкин">*/}
          {/*    </div>*/}
          {/*    <p className="smi-block-note">Дело его жизни:<br> Николай Ягодкин</p>*/}
          {/*    <p className="smi-block-note-min">«ПОнедельник» – Интернет-журнал<br> о&nbsp;бизнесе, карьере*/}
          {/*      и&nbsp;образовании</p>*/}
          {/*  </a>*/}
          {/*</div>*/}

          {/*<div className="col-sm-12 col-md-auto col-lg-3 smi-col">*/}
          {/*  <div className="sidebar-pos">*/}
          {/*    <a href="/about/news/kakoj_yazik_uchit_posle_anglijskogo/" rel="nofollow">*/}
          {/*      <img src="https://fs.advance.ru/landing-pages/images/about_us/smi/logo_rbk.png"*/}
          {/*           alt="Репортаж Первого канала о Николае Ягодкине и тренинговом клубе Advance">*/}
          {/*    </a>*/}
          {/*  </div>*/}
          {/*  <p className="smi-block-note">РБК</p>*/}
          {/*  <p className="smi-block-note-min">Какой иностранный язык учить после английского</p>*/}
          {/*</div>*/}
        </div>
      </div>
    </section>
  );
};
